/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InitReceiptByApplication } from '../../models/init-receipt-by-application';

export interface ApiRequestInvoiceGetApplicationGet$Params {
}

export function apiRequestInvoiceGetApplicationGet(http: HttpClient, rootUrl: string, params?: ApiRequestInvoiceGetApplicationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InitReceiptByApplication>>> {
  const rb = new RequestBuilder(rootUrl, apiRequestInvoiceGetApplicationGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InitReceiptByApplication>>;
    })
  );
}

apiRequestInvoiceGetApplicationGet.PATH = '/api/Request/Invoice/GetApplication';
